import React from 'react';
import classNames from 'classnames';
import { TPost } from '../../../../types/Post';
import s from './Post.module.scss';
import { PollItems } from './PollItems/PollItems';
import PostMedia from './PostMedia/PostMedia';

export function PostContent(post: TPost, cdnRoot: string): React.ReactNode {
	return (
		post.type === 'pollPost' ?
			<PollItems post={post} /> :
			post.type === 'galleryPost' || post.type === 'videoPost' ?
				<PostMedia post={post} cdnRoot={cdnRoot} /> :
				post.type === 'outfitPost' ? 
				<div
					className={classNames(
						s.wishlistGrid,
						s[`grid-snap-${post.items?.slice(0, 9).length}`],
						s.outfitPost)}
				>
					{(post.items && post.items.length) && post.items.slice(0, 9).map((item, index) => <img
						key={item.img}
						src={item.img}
						alt={item.title} className={`imgIndex${index + 1}`} />
					)}
				</div>
					: null);
}
